import Input from '@/components/Common/Input';
import Select from '@/components/Common/Select';
import { Box, Button, Checkbox, FormControlLabel, Grid2 as Grid, IconButton, Paper, Typography } from '@mui/material';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { RiDeleteBin6Line } from 'react-icons/ri';

export default function AppointmentConfig() {
  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'appointment_booking_details' // ✅ BE KEY
  });

  return (
    <Paper variant='outlined' sx={{ p: 3 }}>
      <Typography fontWeight={600} mb={2}>
        Provider Configuration
      </Typography>

      {fields.map((currField, index) => (
        <Box key={currField.id} mb={3} border='1px solid #ECECEC' padding={2} borderRadius='6px'>
          {/* HEADER */}
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Typography fontWeight={500}>Provider {index + 1}</Typography>

            {index > 0 && (
              <IconButton color='error' onClick={() => remove(index)}>
                <RiDeleteBin6Line />
              </IconButton>
            )}
          </Box>

          {/* PROVIDER NAME */}
          <Box mt={2}>
            <Input
              name={`appointment_booking_details.${index}.provider_name`} // ✅ BE KEY
              control={control}
              label='Provider Name'
              fullWidth
            />
          </Box>

          {/* PROCEDURES */}
          <Typography mt={3} mb={2} fontWeight={500}>
            Top 5 Procedures / Services
          </Typography>

          <Grid container spacing={2}>
            {[0, 1, 2, 3, 4].map((i) => (
              <Grid key={i} size={{ xs: 12, md: 6 }}>
                <Input
                  name={`appointment_booking_details.${index}.procedures.${i}`} // ✅ BE KEY
                  control={control}
                  label={`Procedure ${i + 1}`}
                  fullWidth
                />
              </Grid>
            ))}
          </Grid>

          {/* APPOINTMENT TYPE */}
          <Typography mt={3} mb={1} fontWeight={500}>
            Appointment Type
          </Typography>

          <Controller
            name={`appointment_booking_details.${index}.appointment_type`} // ✅ BE KEY (single value)
            control={control}
            defaultValue='in_person'
            render={({ field }) => {
              const options = [
                { label: 'In Person', value: 'in_person' },
                { label: 'Remote', value: 'remote' },
                { label: 'Hybrid', value: 'hybrid' }
              ];

              return (
                <Box
                  display='flex'
                  gap={{ xs: 0, sm: 2 }}
                  sx={{ flexDirection: { xs: 'column', sm: 'row' }, flexWrap: 'wrap' }}
                >
                  {options.map((opt) => (
                    <FormControlLabel
                      key={opt.value}
                      control={
                        <Checkbox checked={field.value === opt.value} onChange={() => field.onChange(opt.value)} />
                      }
                      label={opt.label}
                    />
                  ))}
                </Box>
              );
            }}
          />

          {/* DURATION */}
          <Box mt={2}>
            <Select
              name={`appointment_booking_details.${index}.appointment_duration`} // ✅ BE KEY
              control={control}
              label='Appointment Duration'
              options={[
                { label: '15 minutes', value: 15 },
                { label: '30 minutes', value: 30 },
                { label: '45 minutes', value: 45 },
                { label: '60 minutes', value: 60 },
                { label: '90 minutes', value: 90 },
                { label: '120 minutes', value: 120 }
              ]}
              fullWidth
            />
          </Box>
        </Box>
      ))}

      {/* ADD PROVIDER */}
      <Button
        variant='outlined'
        sx={{
          borderRadius: 20,
          borderColor: '#777',
          color: '#777',
          minHeight: 32
        }}
        onClick={() =>
          append({
            provider_name: '',
            procedures: ['', '', '', '', ''],
            appointment_type: 'in_person',
            appointment_duration: 30
          })
        }
      >
        + Add Provider
      </Button>
    </Paper>
  );
}
